import directives from './module';
import SpinnerSvc from 'services/SpinnerSvc';
import {Utils} from 'underscore-extensions';

directives.directive('toggleClass', () =>
    (scope: any, element: ng.IAugmentedJQuery, attrs: any) => {
        const className             = attrs.toggleClass,
              classList             = element[0].classList,
              handlerClickOutside   = (e: MouseEvent) => {
                  document.body.removeEventListener('click', handlerClickOutside, true);
                  if (element[0] !== e.target) {
                      classList.remove(className);
                  }
              },
              handlerClickOnElement = () => {
                  if (classList.contains(className)) {
                      classList.remove(className);
                  } else {
                      classList.add(className);
                      document.body.addEventListener('click', handlerClickOutside, true);
                  }
              };

        element[0].addEventListener('click', handlerClickOnElement);

        scope.$on('$destroy', () => {
            element[0].removeEventListener('click', handlerClickOnElement);
            document.body.removeEventListener('click', handlerClickOutside, true);
        });
    }
);

directives.directive('disableTouch', () => (scope: any, element: ng.IAugmentedJQuery) =>
    element.on('touchstart', event => event.preventDefault())
);

directives.directive('eatClick', () => (scope: any, element: ng.IAugmentedJQuery) =>
    element.on('click', event => event.preventDefault())
);

directives.directive('plainClick', $parse =>
    (scope: any, element: ng.IAugmentedJQuery, attrs: any) => {
        const fn = $parse(attrs.plainClick, null, true);
        element.on('click', e => scope.$apply(() => fn(scope, {$event: e})));
    }
);

directives.directive('staticInclude', ($compile: ng.ICompileService,
                                       $templateRequest: ng.ITemplateRequestService) =>
    (scope: any, element: ng.IAugmentedJQuery, attrs: any) => {
        $templateRequest(attrs.staticInclude || attrs.src).then(response => {
            const contents = element.html(response).contents();
            $compile(contents)(scope);
        });
    }
);

directives.component('loadingSpin', {
    template: `<div id="loading-spin">
                <img class="spin" ng-src="${require('../../images/spin.png')}" width="224" height="224"/>
               </div>`
});

directives.component('spinner', {
    template: (() =>
        `<div class="spinner">${new Array(13).join('<div class="spinner-blade"></div>')}</div>`)()
});

directives.component('loaderHorizontal', {
    template: `<div class="loader-horizontal">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
               </div>`
});


directives.directive('initScope', () => ({
    priority: 10000,
    link (scope: any, element: ng.IAugmentedJQuery, attrs: any) {
        const expressions: string[] = attrs.initScope.split(';');
        expressions.forEach(exp =>
            scope.$watch(exp.split('=')[1], () =>
                scope.$eval(attrs.initScope)
            )
        );
    }
}));

directives.directive('checkAutofill', ($interval) =>
    (scope: any, element: any) => {
        const intervalId = $interval(() => {
            element.triggerHandler('input').triggerHandler('change').triggerHandler('keydown');
        }, 250);
        scope.$on('$destroy', () => $interval.cancel(intervalId));
    }
);

const model = (name: string, link: Function) =>
    directives
        .directive(name, () => ({require: 'ngModel', link}));

model('uppercase', (scope: any, element: ng.IAugmentedJQuery, attrs: any, ngModel: ng.INgModelController) => {
    ngModel.$parsers.unshift(input => input ? input.toUpperCase() : '');
    element[0].style.textTransform = 'uppercase';
});
model('stringToNumber', (scope: any, element: ng.IAugmentedJQuery, attrs: any, ngModel: ng.INgModelController) => {
    ngModel.$parsers.push(value => '' + value);
    ngModel.$formatters.push(value => parseInt(value, 10));
});

directives.directive('lazyIf', ($animate, $compile) => {
    return {
        restrict: 'A',
        scope: false,
        terminal: true,
        priority: 1000,
        compile(element: ng.IAugmentedJQuery, attrs: any) {
            let content = element[0].innerHTML;
            element.html('');
            return (scope: ng.IScope) => {
                const unwatch = scope.$watch(attrs.lazyIf, (value: boolean) => {
                    if (value) {
                        element.append(content);
                        element.removeAttr('lazy-if');
                        $animate.enter($compile(element)(scope), null, element).then(() => {
                            unwatch();
                            content = null;
                        });
                    }
                });

            };
        }
    };
});

//works only in ProjectPage
directives.directive('lazyButton', ($compile, $parse, $location, $ocLazyLoad) => {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            module: '=',
            onShown: '=?',
            onClick: '&?'
        },
        link(scope: any, element: ng.IAugmentedJQuery, attr: any) {
            scope.shown  = false;
            scope.title  = attr.btnName;
            scope.enable = _.once(() => {
                SpinnerSvc.show();
                scope.loading = true;
                const module  = _.isFunction(scope.module) ? scope.module() : scope.module;
                module.then((m: oc.Module) => $ocLazyLoad.load(m)).then(() => {
                    scope.$watch(() => scope.$parent.project, (p: anm.Project) => {
                        p && $compile(element[0].querySelector('ng-transclude').firstElementChild)(scope);
                    });
                    scope.loading = false;
                    SpinnerSvc.hide();
                });
            });
            if ($location.search()[attr.queryParam]) {
                scope.enable();
                scope.shown = true;
            }
            scope.show = () => {
                scope.enable();
                scope.shown = !scope.shown;
                if (_.isFunction(scope.onClick)) {
                    scope.onClick();
                }
                if (_.isFunction(scope.onShown)) {
                    scope.onShown(scope, scope.shown);
                }
            };
        },
        template: `<a href="#" ng-click="show()" class="control lazy-link"
                      ng-class="{loading:loading}"><span class="title">{{::title}}</span></a>
                   <ng-transclude></ng-transclude>`
    };
});

directives.filter('startFrom', () => (input: any[], start: string) => input.slice(parseInt(start, 10)));

directives.directive('focusMe',
    () => (scope: any, element: ng.IAugmentedJQuery) => new Promise(() => element[0].focus()));

directives.directive('unFocusMe',
    () => (scope: any, element: ng.IAugmentedJQuery, attr: any) =>
        scope.$watch(() => scope.$eval(attr.unFocusMe), (a: boolean) => a && element[0].blur()));

directives.directive('modelChange', () => ({
    restrict: 'A',
    require: 'ngModel',
    link (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: any, ctrl: ng.INgModelController) {
        scope.$watch(() => ctrl.$viewValue, () => scope.$eval(attr.modelChange));
    }
}));
directives.directive('translateModel', (TranslateSvc) => ({
    restrict: 'A',
    require: 'ngModel',
    link(scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) {
        ctrl.$formatters.push(s => s && s.split(',').map((v: string) => TranslateSvc.get(v.trim())).join(', '));
    }
}));

directives.directive('typer', (TranslateSvc) => ({
    scope: {typer: '='},
    link(scope: any, element: ng.IAugmentedJQuery) {
        const n        = scope.typer.length;
        let current    = 0;
        let id: number = null;

        const changeText = () => {
            element[0].innerHTML = '';
            const letters        = TranslateSvc.get(scope.typer[current++ % n] + '.tab').split('');
            const type           = () => {
                element[0].innerHTML += letters.shift();
                if (letters.length > 0) {
                    id = setTimeout(() => type(), 40 + Math.round(Math.random() * 30));
                } else {
                    id = setTimeout(() => changeText(), 2000);
                }
            };
            type();
        };
        changeText();
        scope.$on('$destroy', () => clearTimeout(id));
    }
}));

directives.directive('longText', (TranslateSvc) => ({
    scope: {
        longText: '=',
        longTextCb: '&?'
    },
    link(scope: any, element: ng.IAugmentedJQuery) {
        setTimeout(() => {
            const len = element.text().length;
            if(scope.longText < len)
                scope.longTextCb();
        }, 0);
    }
}));


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/smallDirectives.ts